import { Stack, Typography, useTheme } from "@mui/material";
import { CheckCircleIcon, CopyInvertedIcon, InfoIcon, Input } from "components";
import { useState } from "react";

export const CopyWebhookUrl = ({ webhookUrl }: { webhookUrl: string }) => {
  return (
    <Stack gap="28px">
      <Stack
        p="12px 16px"
        border="1px solid #98C6F1"
        borderRadius="8px"
        bgcolor="#E8F3FE"
        direction="row"
        alignItems={"flex-start"}
        gap="8px"
      >
        <InfoIcon
          sx={{
            color: "#0075C8",
          }}
        />
        <Stack gap="8px">
          <Typography variant="subtitle1" color="#0075C8">
            Copy the webhook URL and paste it in your Datto account.
          </Typography>
          <Typography variant="body-small">
            Integrations {">"} Global Webhooks {">"} <strong>Enable</strong>{" "}
            “Webhook globally for monitors” {">"} <strong>Update</strong> URL in
            “Send a Webhook” {">"} <strong>Update</strong> URL in “When alert is
            resolved (optional)” {">"} <strong>Save</strong>
          </Typography>
        </Stack>
      </Stack>
      <Stack gap="16px" width="100%">
        <Typography variant="h6">Webhook</Typography>
        <Stack gap="8px">
          <Typography variant="body-small">Webhook URL</Typography>
          <InputField
            name="webhook_url"
            label="Webhook URL"
            value={`${webhookUrl}?status=create`}
          />
        </Stack>
        <Stack gap="8px">
          <Typography variant="body-small">
            Resolved alert webhook URL
          </Typography>
          <InputField
            name="resolved_webhook_url"
            label="Resolved alert webhook URL"
            value={`${webhookUrl}?status=close`}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

const InputField = ({
  name,
  label,
  value,
}: {
  name: string;
  label: string;
  value: string;
}) => {
  const theme = useTheme();
  const [isShowValueCopied, setIsShowValueCopied] = useState(false);
  const copyValue = (value: string) => {
    navigator.clipboard.writeText(value);
    setIsShowValueCopied(true);
    setTimeout(() => {
      setIsShowValueCopied(false);
    }, 1000);
  };
  return (
    <Input
      hideHelperBox
      name={name}
      // label={label}
      value={value}
      InputProps={{
        endAdornment: isShowValueCopied ? (
          <CheckCircleIcon color="success" fontSize="small" />
        ) : (
          <CopyInvertedIcon
            fontSize="small"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => {
              copyValue(value);
            }}
          />
        ),
      }}
      disabled={true}
    />
  );
};
